import { UserDto } from '@agroone/entities'
import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '@front-app-environments/environment'
import { map, Observable, of, shareReplay } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly http = inject(HttpClient)
  private readonly url = `${environment.apiUrl}${environment.users}/me`

  private user$: Observable<UserDto> | null = null

  getUser(): Observable<UserDto> {
    if (!this.user$) {
      this.user$ = this.http.get<UserDto>(this.url).pipe(
        map((user) => new UserDto(user)),
        shareReplay(1),
      )
    }
    return this.user$
  }

  setUser(user: UserDto): void {
    this.user$ = of(user)
  }

  getRegionName(): Observable<string> {
    return this.getUser().pipe(map((user) => user.regionName))
  }
}
